import axios from 'axios';

export default {
    fetchAll() {
        return axios.post('/errorReportError/fetchAll/');
    },
    save(errors) {
        return axios.post('/errorReportError/save/', { errors });
    },
};
